import { Button, Text } from 'frosted-ui';
import type { OfferType } from './unlockDraft';

const OPTIONS: Array<{ id: OfferType; title: string; body: string }> = [
  {
    id: 'membership',
    title: 'Membership',
    body: 'Test the price of a product you already sell.',
  },
  {
    id: 'unlock',
    title: 'Pay-to-unlock',
    body: 'Sell one image (a pick, a chart, a guide) behind a blurred preview.',
  },
];

interface OfferTypeChoiceProps {
  value: OfferType;
  onChange: (value: OfferType) => void;
}

/** What's being sold: the first choice on the link and partner paths. */
export default function OfferTypeChoice({ value, onChange }: OfferTypeChoiceProps) {
  return (
    <div>
      <div
        role="radiogroup"
        aria-label="What are you selling"
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-2)' }}
      >
        {OPTIONS.map((option) => {
          const selected = value === option.id;
          return (
            <Button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={selected}
              size="2"
              variant={selected ? 'solid' : 'surface'}
              color={selected ? undefined : 'gray'}
              style={{ minHeight: 44 }}
              onClick={() => onChange(option.id)}
            >
              {option.title}
            </Button>
          );
        })}
      </div>
      <Text size="1" color="gray" style={{ display: 'block', marginTop: 'var(--space-1)' }}>
        {OPTIONS.find((o) => o.id === value)?.body}
      </Text>
    </div>
  );
}
